import { Component, OnInit } from '@angular/core';
import {ICellRendererParams} from 'ag-grid-community';
import {AgRendererComponent} from 'ag-grid-angular';
// import { Router } from "@angular/router";
@Component({
  selector: 'app-sources-render',
  templateUrl: './sources-render.component.html',
  styleUrls: ['./sources-render.component.scss']
})
export class SourcesRenderComponent implements AgRendererComponent {

  public params: ICellRendererParams;
  userId;
  isOrgAdmin;
  status: any;
  focusIndex: number;
  dataLength;
  agInit(params: ICellRendererParams): void {
      this.params = params;
      this.dataLength = this.params['dataLength'];
     // console.log(this.params,"jj")
  }

  public invokeParentMethod() {
      this.params.context.componentParent.methodFromParent(`Row: ${this.params.node.rowIndex}, Col: ${this.params.colDef.headerName}`);
  }

  refresh(): boolean {
      return false;
  }

  redirectSources() {
    this.params.context.componentParent.routeToSources(this.params.data.warehouseId, this.params.data.type);

  }

  setWarehouse(sourceId, warehouseId, type) {
    this.params.context.componentParent.setWarehouse(sourceId, warehouseId, type);
  }

}
